<template>
    <div class="container-fluid content-wrapper">
        <p-form @submit="onSubmit">
            <b-row class="content-heading">
                <b-col>
                    <div>Email Templates</div>
                </b-col>
                <b-col cols="auto" class="ms-auto">
                    <p-button variant="primary" :is-busy="isBusy" type="submit"
                        >Save
                    </p-button>
                </b-col>
            </b-row>
            <b-tabs justified>
                <b-tab title="Web">
                    <b-row class="no-gutters">
                        <b-col md="10">
                            <p-card>
                                <b-row>
                                    <b-col>
                                        <h4>Processing Order</h4>
                                    </b-col>
                                    <b-col cols="auto" class="ms-auto me-2">
                                        <p-checkbox
                                            label="Active"
                                            v-model="
                                                emailDetailProcessingOrder.isActive
                                            "
                                        >
                                        </p-checkbox>
                                    </b-col>
                                </b-row>
                                <EmailTemplate
                                    :emailDetail="emailDetailProcessingOrder"
                                />
                            </p-card>
                            <p-card>
                                <b-row>
                                    <b-col>
                                        <h4>Backorder Notification</h4>
                                    </b-col>
                                    <b-col cols="auto" class="ms-auto me-2">
                                        <p-checkbox
                                            label="Active"
                                            v-model="
                                                emailDetailBackorderNotification.isActive
                                            "
                                        >
                                        </p-checkbox>
                                    </b-col>
                                </b-row>
                                <EmailTemplate
                                    :emailDetail="emailDetailBackorderNotification"
                                />
                            </p-card>
                            <p-card>
                                <b-row>
                                    <b-col>
                                        <h4>Shipping Order / Ready for Pickup</h4>
                                    </b-col>
                                    <b-col cols="auto" class="ms-auto me-2">
                                        <p-checkbox
                                            label="Active"
                                            v-model="emailDetailShippingOrder.isActive"
                                        >
                                        </p-checkbox>
                                    </b-col>
                                </b-row>
                                <EmailTemplate
                                    :emailDetail="emailDetailShippingOrder"
                                />
                            </p-card>
                            <p-card>
                                <b-row>
                                    <b-col>
                                        <h4>Cancel Order</h4>
                                    </b-col>
                                    <b-col cols="auto" class="ms-auto me-2">
                                        <p-checkbox
                                            label="Active"
                                            v-model="emailDetailCancelOrder.isActive"
                                        >
                                        </p-checkbox>
                                    </b-col>
                                </b-row>
                                <EmailTemplate :emailDetail="emailDetailCancelOrder" />
                            </p-card>
                        </b-col>
                        <b-col md="2" class="ps-3">
                            <p-card class="h-100">
                                <h4 class="mb-3">Template Placeholders</h4>
                                <p-input 
                                    v-model="tokenSearch" 
                                    type="search"
                                    placeholder="Search placeholders..."
                                    class="mb-3">
                                </p-input>
                                <div class="token-list">
                                    <div 
                                        v-for="token in filteredTokens" 
                                        :key="token.value"
                                        class="token-item mb-2 pb-2 border-bottom"
                                        @click="copyTokenToClipboard(token.value)"
                                        style="cursor: pointer;">
                                        <div class="d-flex justify-content-between align-items-start">
                                            <div class="flex-grow-1 me-2">
                                                <div class="font-weight-bold text-monospace">{{ token.value }}</div>
                                                <div class="token-description">{{ token.description }}</div>
                                            </div>
                                            <p-button
                                                variant="outline-primary"
                                                size="sm"
                                                class="py-1 px-2"
                                                @click.stop="copyTokenToClipboard(token.value)">
                                                Copy
                                            </p-button>
                                        </div>
                                    </div>
                                    <div v-if="filteredTokens.length === 0" class="text-center text-muted">
                                        No matching placeholders
                                    </div>
                                </div>
                            </p-card>
                        </b-col>
                    </b-row>
                </b-tab>
                <b-tab title="Rental">
                    <b-row class="no-gutters">
                        <b-col md="10">
                            <p-card>
                                <b-row>
                                    <b-col>
                                        <h4> Rental Return Reminder</h4>
                                    </b-col>
                                    <b-col cols="auto" class="ms-auto me-2">
                                        <p-checkbox
                                            label="Active"
                                            v-model="emailDetailRentalReminder.isActive"
                                        >
                                        </p-checkbox>
                                    </b-col>
                                </b-row>
                                <EmailTemplate :emailDetail="emailDetailRentalReminder" />
                            </p-card>
                            <p-card class="mt-3">
                                <b-row>
                                    <b-col>
                                        <h4>Processed Rental Not Returned</h4>
                                    </b-col>
                                    <b-col cols="auto" class="ms-auto me-2">
                                        <p-checkbox
                                            label="Active"
                                            v-model="emailDetailProcessRNR.isActive"
                                        >
                                        </p-checkbox>
                                    </b-col>
                                </b-row>
                                <EmailTemplate :emailDetail="emailDetailProcessRNR" />
                            </p-card>
                        </b-col>
                        <b-col md="2" class="ps-3">
                            <p-card class="h-100">
                                <h4 class="mb-3">Template Placeholders</h4>
                                <p-input 
                                    v-model="tokenSearch" 
                                    type="search"
                                    placeholder="Search placeholders..."
                                    class="mb-3">
                                </p-input>
                                <div class="token-list">
                                    <div 
                                        v-for="token in filteredTokens" 
                                        :key="token.value"
                                        class="token-item mb-2 pb-2 border-bottom"
                                        @click="copyTokenToClipboard(token.value)"
                                        style="cursor: pointer;">
                                        <div class="d-flex justify-content-between align-items-start">
                                            <div class="flex-grow-1 me-2">
                                                <div class="font-weight-bold text-monospace">{{ token.value }}</div>
                                                <div class="token-description">{{ token.description }}</div>
                                            </div>
                                            <p-button
                                                variant="outline-primary"
                                                size="sm"
                                                class="py-1 px-2"
                                                @click.stop="copyTokenToClipboard(token.value)">
                                                Copy
                                            </p-button>
                                        </div>
                                    </div>
                                    <div v-if="filteredTokens.length === 0" class="text-center text-muted">
                                        No matching placeholders
                                    </div>
                                </div>
                            </p-card>
                        </b-col>
                    </b-row>
                </b-tab>
            </b-tabs>
        <b-row>
            <b-col class=" mt-3 text-center">
                <p-button
                    variant="primary"
                    type="submit"
                    :is-busy="isBusy"
                    >Save</p-button
                >
            </b-col>
        </b-row>
      </p-form>
    </div>
</template>

<script>
import NavigationGuard from '@/components/mixins/NavigationGuard.js';
import EmailTemplate from '../../components/EmailTemplate.vue';
import axios from 'axios';
export default {
    mixins: [NavigationGuard],
    components: {
        EmailTemplate
    },
    props: {},
    data() {
        return {
            isBusy: false,
            customEmailTemplateDetails: [],
            tokenSearch: '',
            tokens: [],
            emailDetailProcessingOrder: {
                name: 'Processing Order',
                isActive: false
            },
            emailDetailBackorderNotification: {
                name: 'Backorder Notification',
                isActive: false
            },
            emailDetailShippingOrder: {
                name: 'Shipping Order',
                isActive: false
            },
            emailDetailCancelOrder: {
                name: 'Cancel Order',
                isActive: false
            },
            emailDetailRentalReminder: {
                name: 'Rental Reminder',
                isActive: false
            },
            emailDetailProcessRNR: {
                name: 'Process Rental Not Returned',
                isActive: false
            }           
        };
    },
    mounted: async function() {
        await this.loadData();
    },
    computed: {
        filteredTokens() {
            if (!this.tokenSearch) {
                return this.tokens;
            }
            const searchLower = this.tokenSearch.toLowerCase();
            return this.tokens.filter(token => 
                token.value.toLowerCase().includes(searchLower) ||
                token.description.toLowerCase().includes(searchLower));
        }
    },
    methods: {
        async loadData() {
            axios.get('CustomEmailTemplate').then(res => {
                this.customEmailTemplateDetails = res.data.customEmailTemplateDetails;

                if (res.data.emailTemplateTokens) {
                    this.tokens = Object.values(res.data.emailTemplateTokens).map(token => ({
                        value: token.token,
                        description: token.description
                    }));
                }

                this.emailDetailProcessingOrder = this.getEmailTemplate('Processing Order', this.emailDetailProcessingOrder);
                this.emailDetailBackorderNotification = this.getEmailTemplate('Backorder Notification', this.emailDetailBackorderNotification);
                this.emailDetailShippingOrder = this.getEmailTemplate('Shipping Order', this.emailDetailShippingOrder);
                this.emailDetailCancelOrder = this.getEmailTemplate('Cancel Order', this.emailDetailCancelOrder);
                this.emailDetailRentalReminder = this.getEmailTemplate('Rental Reminder', this.emailDetailRentalReminder);
                this.emailDetailProcessRNR = this.getEmailTemplate('Process Rental Not Returned', this.emailDetailProcessRNR);
                
                this.dataLoaded();
            });
        },
        copyTokenToClipboard(token) {
            navigator.clipboard.writeText(token).then(() => {
                this.$appSuccess(`Token "${token}" copied to clipboard.`)
            }).catch(() => {
                this.$appError('Failed to copy token to clipboard.')
            });
        },
        getEmailTemplate(templateName, emailDetail) {
            let emailTemplate = this.customEmailTemplateDetails.find(x => x.name == templateName);
            return emailTemplate === undefined
                ? emailDetail
                : emailTemplate;
        },
        upsertEmailTemplate(template) {
            const emailTemplate = this.customEmailTemplateDetails.find(x => x.name === template.name);
            if (emailTemplate) {
                Object.assign(emailTemplate, template);
            } else {
                this.customEmailTemplateDetails.push(template);
            }
        },    
        onSubmit() {
            // No token in From Name or Reply to fields
            const invalidFields = this.validateNoTokensInRestrictedFields();
            if (invalidFields.length > 0) {
                this.$appError(`Placeholders cannot be used in: ${invalidFields.join(', ')}. Please remove them.`)
                return;
            }

            this.upsertEmailTemplate(this.emailDetailProcessingOrder);
            this.upsertEmailTemplate(this.emailDetailBackorderNotification);
            this.upsertEmailTemplate(this.emailDetailShippingOrder);
            this.upsertEmailTemplate(this.emailDetailCancelOrder);
            this.upsertEmailTemplate(this.emailDetailRentalReminder);
            this.upsertEmailTemplate(this.emailDetailProcessRNR);

            this.isBusy = true;
            axios
                .post('CustomEmailTemplate', {
                    customEmailTemplateDetails: this.customEmailTemplateDetails
                })
                .then(() => {
                    this.dataSaved();
                    this.loadData();
                    this.$appSuccess(`Email templates saved successfully.`)
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },
        validateNoTokensInRestrictedFields() {
            const tokenPattern = /{{[^}]+}}/g;
            const invalidFields = [];

            const templates = [
                { template: this.emailDetailProcessingOrder, name: 'Processing Order' },
                { template: this.emailDetailBackorderNotification, name: 'Backorder Notification' },
                { template: this.emailDetailShippingOrder, name: 'Shipping Order' },
                { template: this.emailDetailCancelOrder, name: 'Cancel Order' },
                { template: this.emailDetailRentalReminder, name: 'Rental Reminder' },
                { template: this.emailDetailProcessRNR, name: 'Process Rental Not Returned' }
            ];

            templates.forEach(item => {
                const fromName = item.template.fromName || '';
                const replyEmail = item.template.replyEmail || '';

                if (tokenPattern.test(fromName)) {
                    invalidFields.push(`${item.name} From Name`);
                }
                if (tokenPattern.test(replyEmail)) {
                    invalidFields.push(`${item.name} Reply to`);
                }
            });

            return [...new Set(invalidFields)];
        },        
    },
    watch: {
        emailDetailProcessingOrder: NavigationGuard.$watcher,
        emailDetailBackorderNotification: NavigationGuard.$watcher,
        emailDetailShippingOrder: NavigationGuard.$watcher,
        emailDetailCancelOrder: NavigationGuard.$watcher,
        emailDetailRentalReminder: NavigationGuard.$watcher,
        emailDetailProcessRNR: NavigationGuard.$watcher,
        $route: function(to, from) {
            if (to !== from) {
                this.loadData();
            }
        }
    }
};
</script>

<style scoped lang="scss">
.token-list {
    display: flex;
    flex-direction: column;
}

.token-item {
    &:last-child {
        border-bottom: none;
    }
}

.text-monospace {
    font-family: 'Courier New', Courier, monospace;
    font-size: 0.95rem;
    font-weight: bold;
}

.token-description {
    font-size: 0.85rem;
    color: #495057;
    margin-top: 0.125rem;
}
</style>